import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../components/home.vue'
// import Market from '../components/market.vue'
// import AI from '../components/ai.vue'
import Case from '../components/case.vue'
import newMarket from '../views/market.vue'
import Device from '../views/device.vue'
import About from '../views/about.vue'
import Retail from '../views/retail.vue'
import AI from '../views/AI.vue'
import DOC from '../views/doc.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: newMarket },
    // { path: '/market1', component: Market },
    { path: '/AI', component: AI },
    { path: '/case', component: Case },
    // { path: '/market', component: newMarket },
    { path: '/device', component: Device },
    { path: '/about', component: About },
    { path: '/retail', component: Retail },
    { path: '/doc', component: DOC }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
